// Controllers used across the site. The gallery's (three.js) is registered by the
// separate `galerie` bundle, loaded only on gallery pages (layouts/gallery).
import { application } from "./application"
import ArViewerController from "./ar_viewer_controller"
import CatalogueModalController from "./catalogue_modal_controller"
import ClipboardController from "./clipboard_controller"
import CountUpController from "./count_up_controller"
import DrawerController from "./drawer_controller"
import ExpositionTypeController from "./exposition_type_controller"
import GeolocationController from "./geolocation_controller"
import HeaderController from "./header_controller"
import NativeSubmitController from "./native_submit_controller"
import OeuvresOrderController from "./oeuvres_order_controller"
import RequestErrorController from "./request_error_controller"
import SegmentedController from "./segmented_controller"
import SignPreviewController from "./sign_preview_controller"
import SubmitShortcutController from "./submit_shortcut_controller"
import TrackController from "./track_controller"

application.register("ar-viewer", ArViewerController)
application.register("catalogue-modal", CatalogueModalController)
application.register("clipboard", ClipboardController)
application.register("count-up", CountUpController)
application.register("drawer", DrawerController)
application.register("exposition-type", ExpositionTypeController)
application.register("geolocation", GeolocationController)
application.register("header", HeaderController)
application.register("native-submit", NativeSubmitController)
application.register("oeuvres-order", OeuvresOrderController)
application.register("request-error", RequestErrorController)
application.register("segmented", SegmentedController)
application.register("sign-preview", SignPreviewController)
application.register("submit-shortcut", SubmitShortcutController)
application.register("track", TrackController)
